<template>
 <!-- Barre latérale -->
  <div class=" h-screen  ">
    <!-- Logo du tableau de bord -->
    <router-link class=" " to="/home">
       
        <img src="../assets/AP.png" alt="Logo" class="h-24  w-auto mx-auto my-auto mt-9" />
        
        
      </router-link>
  <!-- Contenu du tableau de bord -->
  <div class="w-full ">
    <slot/>
  </div>
</div>
</template>

<script>
export default {
  name: 'LoginLayout',
};
</script>

<style scoped>
.custom-background {
  background-image: url('~@/assets/full-shot-smiley-woman-watching-movie-tablet.jpg');
  /* Remplacez 'votre-image.jpg' par le nom de votre image */
  background-size: cover;
  /* Ajustez la taille de l'image */
  background-repeat: no-repeat;
  background-position: center center;
  /* Centrez l'image */
  /* Ajoutez d'autres styles Tailwind CSS ou CSS personnalisés au besoin */
}

/* Ajoutez des styles personnalisés pour le slider ici */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
